<template lang="pug">
    .sud-card-caption
      slot
</template>


<script>
export default {
  name:'app-card-caption'
}
</script>


<style scoped>
.sud-card-caption {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  /* font-size: 12px; */
  font-size: 14px;
  line-height: 18px;
  color: #757575;
}
</style>
